import { Box } from '@rbilabs/universal-components';

import { spacing } from 'styles/constants';

export const screenReaderOnly = Box.withConfig({
  height: spacing.$0_5,
  margin: '-1px',
  overflow: 'hidden',
  padding: '0',
  position: 'absolute',
  width: spacing.$0_5,
});
